<app-header [productLength]="productLength"></app-header>
<br><br><br>
<div class="container">

    <div id="demo" class="carousel slide" data-ride="carousel">

        <!-- Indicators -->
        <ul class="carousel-indicators">
            <li data-target="#demo" data-slide-to="0" class="active"></li>
            <li data-target="#demo" data-slide-to="1"></li>
            <li data-target="#demo" data-slide-to="2"></li>
        </ul>

        <!-- The slideshow -->
        <div class="carousel-inner">
            <div class="carousel-item active">
                <img src="https://previews.123rf.com/images/leoedition/leoedition1708/leoedition170800390/84001974-banner-online-book-store-book-shelf-or-bookcase-on-the-background.jpg" alt="Los Angeles" width="1100" height="500">
            </div>
            <div class="carousel-item">
                <img src="https://thumbs.dreamstime.com/b/multiethnic-people-books-white-background-bookstore-library-banner-poster-design-template-students-men-women-178820655.jpg" alt="Chicago" width="1100" height="500">
            </div>
            <div class="carousel-item">
                <img src="https://i.pinimg.com/736x/d6/16/44/d61644e4d341b58cdb27cc5ecf6fd3dd.jpg" alt="New York" width="1100" height="500">
            </div>
        </div>

        <!-- Left and right controls -->
        <a class="carousel-control-prev" href="#demo" data-slide="prev">
            <span class="carousel-control-prev-icon"></span>
        </a>
        <a class="carousel-control-next" href="#demo" data-slide="next">
            <span class="carousel-control-next-icon"></span>
        </a>
    </div>
    <BR>
    <div class="row jumbotron">
        <div class="col-md-6">
            <h2 style="text-decoration: underline;">KRM Shillong</h2>
            <p>KRM Shillong is an Online Book Store with the main objective of providing you with all the book. KRM Shillong provides you with over 300 Books from over 50 brands.</p>
            <p>You have the option to choose the products from different Categories on the Homepage customized to make you easy to navigate and to find out what you are looking for. We ensure that your time will be saved and you will receive best quality
                of the products and services from us.</p>
            <p>Thank you for your time and effort to know more about us. <mark>HAPPY SHOPPING!</mark></p>
        </div>

        <div class="col-md-6">
            <img class="img-thumbnail" src="https://minibasketshillong.com/images/minibasket_shillong.png">
        </div>

    </div>

</div>

<app-footer></app-footer>